import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { TOKENS } from '../constants';

// RN's `borderStyle: 'dashed'` only renders when all four borders share the
// same width. We clip a fully-bordered box to a 1px-tall window so only the
// top edge shows.
export const DashedSeparator = memo(() => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      css={`
        margin: 0 ${rpx(14)}px;
        height: ${rpx(1)}px;
        overflow: hidden;
      `}
    >
      <View
        css={`
          border-width: ${rpx(1)}px;
          border-color: ${TOKENS.divider};
          border-style: dashed;
          border-radius: ${rpx(1)}px;
          height: ${rpx(2)}px;
        `}
      />
    </View>
  );
});
